import React from "react";
import Navbar from "../../Components/Navigation/Navbar";
import { Button, Card, Row, Col, Image } from "react-bootstrap";

function YtrainingPage() {
    return (<>
        <Navbar />
        <Card>
            <Card.Header>Kinder- & Jugendtraining</Card.Header>
            <Card.Body>
                <Card.Text>
                Durch unser erfahrenes Team von Übungsleitern, Tauchlehrern und Helfern ist es uns möglich, einen vielseitigen Mix von Schwimmhallentraining und Vereinsveranstaltungen für unsere Kinder und Jugendgruppe anzubieten.
                <br /><br />
                Wir versuchen unseren Jüngsten durch das wöchentliche Training, Wochenendveranstaltungen und Ausflüge in die Natur an den Tauchsport als aktive sportliche Freizeitgestaltung heranzuführen und für unseren bereichernden, wunderschönen Natursport zu begeistern.
                </Card.Text>
                <Card.Text>
                    Lernen, Bewegung und Spaß in der Gruppe!
                    <br /><br />
                    In unserem Kinder-Training geht es neben dem Spaß in der Gruppe und an der Bewegung um das Erlernen der Flossenschwimmtechniken über und unter Wasser (Streckentauchen). Später kommen Atemtechniken und das Apnoetauchen (Tauchen mit angehaltenem Atem ohne Drucklufttauchgerät) dazu.
                    <br /><br />
                    Die Trainingsgruppen sind nach Alter und Ausbildungsstand gestaffelt. Ab dem Alter von 12 Jahren können die Kinder mit der Tauchausbildung mit Drucklufttauchgerät beginnen (Grundtauchschein).
                    <br /><br />
                    <strong>Inhalt des Kinder-Trainings:</strong>
                    <ul>
                        <li>Festigung und Schulung der grundlegenden Schwimm- und Sprungtechniken</li>
                        <li>Motorische Entwicklung und Umgang mit Flossen, Maske und Schnorchel</li>
                        <li>Kennenlernen des Tauchgerätes und der Tauchausrüstung</li>
                        <li>Gewöhnung an die Bewegung im und unter Wasser</li>
                        <li>Verbesserung der Kondition durch regelmäßiges Flossenschwimmen</li>
                    </ul>
                    <br />
                    <strong>Inhalt des Jugend-Trainings:</strong>
                    <ul>
                        <li>Ausbau der Grundfertigkeiten</li>
                        <li>Vorbereitung auf die Ausbildung für das Drucklufttauchen (Scuba-Diving)</li>
                        <li>Apnoetauchen und Umgang mit dem Tauchgerät</li>
                    </ul>
                    <br />
                    <strong>Infos zu unseren Trainingszeiten findest du <a href="/schwimmhallentraining">hier</a>.</strong>
                    <br /><br />
                    Ihr Kind wollte zum Beispiel schon immer …
                    <ul>
                        <li>wissen, wie es sich anfühlt, unter Wasser mit einem Tauchgerät zu atmen</li>
                        <li>schwerelos durch das Wasser gleiten</li>
                        <li>die Unterwasserwelt erkunden</li>
                        <li>wissen, was Taucher so machen</li>
                    </ul>
                    <br />
                    Dann kommen Sie doch zum Probetraining zu uns und wir schauen gemeinsam, ob Ihr Kind den Tauchsport mag und dafür geeignet ist.
                    Wir bieten dreimal eine kostenlose Teilnahme am Training an. Danach kann Ihr Kind gern Mitglied in unserem Verein werden und am gesamten Vereinsleben teilhaben.
                    <br /><br />
                    Zum Probetraining bringen Sie bitte das ausgefüllte Formular für den <a href="/pdfs/Versicherungsschutz_vor_Vereinsaufnahme.pdf" target="_blank" rel="noopener noreferrer">vorläufigen Versicherungsschutz</a> mit. Die Fragen zur Gesundheit müssen für das Kindertraining nicht beantwortet werden.
                    Bitte melden Sie sich vorher per <a href="mailto:vorstand@stahl-taucher.de">E-Mail</a> oder das <a href="/kontakt">Kontaktformular</a> an.
                </Card.Text>
            </Card.Body>
        </Card>



        <Card className="impressum">
            <Button variant="Link" href="/impressum">Impressum</Button>
        </Card>
    </>);
}

export default YtrainingPage;